// LAYOUT
import '../layout.js';

// GSAP
import { gsap , ScrollSmoother , ScrollTrigger } from "../layout.js";
import { gsapSmoothScrollObj } from "../layout.js";
console.log(gsapSmoothScrollObj);

// CONTACT FORM
var wpcf7Elm = document.querySelector( '.wpcf7' );
wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
	jQuery('#contactModal').modal('show');
}, false );


// INPUT PHONE NUMBER ONLY NUMERIC
var inputField = document.querySelector('#phone-number');
inputField.onkeydown = function(event) {
  if(isNaN(event.key) && event.key !== 'Backspace') {
    event.preventDefault();
  }
};